const SHOW_EMPTY_TEAMS_KEY = 'showEmptyTeams';
export const appendEmptyTeamSearchToTql = (tql: string): string => {
  if (tql.includes(SHOW_EMPTY_TEAMS_KEY)) {
    return tql;
  }
  return `${tql.length > 0 ? `(${tql}) AND ` : ''}(${SHOW_EMPTY_TEAMS_KEY} = true)`;
};
